"use strict";

var _slicedToArray = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var notification_action_1 = require("../actions/notification.action");
var ScrollArea_1 = __importDefault(require("./ScrollArea/ScrollArea"));
function NotificationSetting(props) {
  var _ref = (0, hooks_1.useState)([]),
    _ref2 = _slicedToArray(_ref, 2),
    flags = _ref2[0],
    setFlags = _ref2[1];
  var _ref3 = (0, hooks_1.useState)(1),
    _ref4 = _slicedToArray(_ref3, 2),
    refresh = _ref4[0],
    setRefresh = _ref4[1];
  (0, hooks_1.useEffect)(function () {
    (0, notification_action_1.fetchSettings)().then(function (response) {
      setFlags(response.data[0].noti);
    }).catch(function () {});
  }, [refresh]);
  /**
   * 선택
   */
  var handleChangeCheckOne = (0, hooks_1.useCallback)(function (index, key) {
    return function (e) {
      setFlags(function (prevState) {
        var itemIndex = prevState[index].list.findIndex(function (item) {
          return item.key === key;
        });
        prevState[index].list[itemIndex].value = !prevState[index].list[itemIndex].value;
        return prevState.slice();
      });
    };
  }, [flags]);
  /**
   * 초기화
   */
  var handleResetNotificationFlag = (0, hooks_1.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    if (window.confirm("변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.")) {
      (0, notification_action_1.resetNotificationFlag)().then(function (response) {
        setFlags(response.data[0].noti);
      }).catch(function () {});
    }
  }, []);
  /**
   * 저장
   */
  var handleNotificationFlagSave = (0, hooks_1.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    /**
     * true 키만추출
     */
    var keys = flags.map(function (group) {
      return group.list.map(function (item) {
        return item.value === true ? item.key : null;
      }).filter(function (n) {
        return n;
      });
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []).join();
    (0, notification_action_1.updateSettingFlag)(keys).then(function () {
      alert("설정이 저장되었습니다.");
    }).catch(function (error) {
      alert("설정 저장을 실패했습니다.");
    }).finally(function () {
      return setRefresh(function (prev) {
        return prev + 1;
      });
    });
  }, [flags]);
  var handleStepChange = (0, hooks_1.useCallback)(function (e) {
    e.stopPropagation();
    e.preventDefault();
    props.onStepChange("list");
  }, []);
  return (0, preact_1.h)("div", {
    id: "feedAdmin"
  }, (0, preact_1.h)("div", {
    className: "feed_header"
  }, (0, preact_1.h)("h2", null, (0, preact_1.h)("a", {
    href: "",
    id: "btnPrev",
    onClick: handleStepChange
  }, "\uC54C\uB9BC \uCF58\uD150\uCE20 \uC124\uC815")), (0, preact_1.h)("div", {
    className: "btn"
  }, (0, preact_1.h)("a", {
    href: "",
    onClick: handleResetNotificationFlag
  }, "\uCD08\uAE30\uD654"), (0, preact_1.h)("em", null, "\xB7"), (0, preact_1.h)("a", {
    href: "",
    onClick: handleNotificationFlagSave
  }, "\uC800\uC7A5"))), (0, preact_1.h)("div", {
    className: "scroll_area"
  }, (0, preact_1.h)(ScrollArea_1.default, {
    speed: 2,
    className: "scroll_area",
    contentClassName: "content",
    verticalScrollbarStyle: {
      borderRadius: 5
    },
    verticalContainerStyle: {
      borderRadius: 5,
      top: 0
    },
    vertical: true,
    horizontal: false,
    smoothScrolling: true,
    stopScrollPropagation: true
  }, flags.map(function (groups, groupIdx) {
    return (0, preact_1.h)(preact_1.Fragment, null, (0, preact_1.h)("h3", null, groups.group_title), (0, preact_1.h)("div", {
      className: "inner"
    }, groups.list.map(function (item, index) {
      return (0, preact_1.h)("dl", {
        key: index,
        className: "feed_set"
      }, (0, preact_1.h)("dt", null, item.title), (0, preact_1.h)("dd", null, item.sub_title), (0, preact_1.h)("dd", {
        className: "toggle"
      }, (0, preact_1.h)("input", {
        type: "checkbox",
        id: "".concat(item.key, "_checkbox"),
        onChange: handleChangeCheckOne(groupIdx, item.key),
        checked: item.value
      }), (0, preact_1.h)("label", {
        htmlFor: "".concat(item.key, "_checkbox")
      })));
    })));
  }))));
}
exports.default = NotificationSetting;